import { StoreButtons } from "./StoreButtons";
import { Reveal } from "./Reveal";

export const EmailCapture = () => (
  <section id="get" className="relative py-20 md:py-28">
    <div className="mx-auto max-w-[1240px] px-5 md:px-8">
      <div className="relative overflow-hidden rounded-[2rem] bg-ink text-white px-6 py-16 md:px-14 md:py-20 shadow-soft-lg">
        <div className="pointer-events-none absolute -top-16 -left-10 h-64 w-64 rounded-full bg-food-accent/20 blur-[90px]" />
        <div className="pointer-events-none absolute -bottom-20 right-0 h-72 w-72 rounded-full bg-bodycare-accent/20 blur-[100px]" />

        <div className="relative max-w-2xl">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-white/50 mb-3">
              Now available on iPhone
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.08] text-white">
              Download WhatThe<span className="text-food-accent">?</span> Scan today
            </h2>
            <p className="mt-4 text-white/60 max-w-lg leading-relaxed">
              Get 4 free scans the moment you download — no account, no subscription,
              no data tracking. Scan your first product in seconds.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-8">
              <StoreButtons />
            </div>
            <p className="mt-4 text-sm text-white/45">
              One-time purchase · No account required · Zero data tracking
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
